import React, { useState, useEffect, useRef } from 'react';
import { Table, Row, Col, Card, CardBody, Nav, FormText, TabContent, TabPane, ButtonGroup, Input, Button } from 'reactstrap'
import { ConfigServer } from '../../../data/config';
import { useHistory } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import Select from 'react-select';
import { cedimi } from '../../../constant/globalConstantsTypeClients'
import { OverlayPanel } from 'primereact/overlaypanel';
import { Tag } from 'primereact/tag';







export const IndexTypeMicro = (props) => {

    const {
        checkTypeClient, informationPatient, id_company, informationSampling, nim_Notification, listTest, handleCancelWorkOrderUpdate,
        number_format, totalW, listPayMethods, handleDinamicInputWorkOrder, validTotalCredit, AvailablePayMethodByCompany, _adminFinance,
        handleGiveChange, handlePayBill, handleDeletePayMethod, isPayForCompany,
        listPayMethods_valid, subTotalW, totalTaxesW, listPayMethod, valueTax, downloadQuoter,
        checkInvoice, deleteSamplingOrder, modalSample, toggleModalSample, handleDeleteSample, dataInfo, listReturnReason, handleChangeReturnReason,
        loadingIsDevolution, validPorcentejeSpecial,
        modalUpdateSample, toggleModalUpdateSample, handleEdit, formMic, handleChangeSample, saveUpdateSampling, loadingUpdate,
        listSample, handleSample, saveUpdateChangeSampling,
        listSite, handleEditSite, toggleModalUpdateSite, modalUpdateSite, handleChangeSite,
        saveUpdateSite, handleSite, saveUpdateChangeSite, _authorized_sanitary,
        // * CONFIGURATION OBSERVATION
        editObservation, toggleModalUpdateObservation, modalUpdateObservation, handleChangeObservation, saveUpdateObservation



    } = props;


    const history = useHistory();
    var id_quoter = 0
    const [activeTab, setActiveTab] = useState('2');
    const [orgActiveTab, setOrgActiveTab] = useState('1');
    const [isFirstLoad, setIsFirstLoad] = useState(true);

    const [selectedQuotation, setSelectedQuotation] = useState(null);
    const op = useRef(null);

    const [selectedSiteQuotation, setSelectedSiteQuotation] = useState(null);
    const ops = useRef(null);

    const [selectedObservationQuotation, setSelectedObservation] = useState(null);
    const opss = useRef(null);



    useEffect(() => {
        if (isFirstLoad) {
            setIsFirstLoad(false);
        }
    }, [isFirstLoad]);

    // ? CONFIRMATIO QUOTER--

    const groupedData = informationSampling
        .map(sample => {
            id_quoter = sample.id_quoter;

            return (sample.listSamples || [])
                .map(_sample => {
                    if (_sample?.id_mic_detail_sample === 0) {
                        return null;
                    }

                    const relatedTests = listTest.filter(
                        test => test.id_mic_detail_sample === _sample.id_mic_detail_sample
                    );

                    const formattedTests = relatedTests.length > 0
                        ? relatedTests.map(test => ({

                            test_name: test?.name ?? "------",
                            price: test?.price ?? 'No Disponible',
                            contract_number: test?.contract_number ?? 'N/A',
                            id_agreement: test?.id_agreement ?? 0,
                            price_Agremment: test?.price_Agremment ?? 0,
                            config_iva: test?.config_iva ?? false,
                            id_work_order_exam: test?.id_work_order_exam ?? 0,
                            id_work_order_profile: test?.id_work_order_profile ?? 0
                        }))
                        : [];

                    return {
                        id_mic_detail_sample: _sample?.id_mic_detail_sample,
                        folio: _sample?.folio ?? "-----",
                        name_mic_sample: _sample?.name_mic_sample ?? "------",
                        name_mic_sampling: _sample?.name_mic_sampling ?? "----",
                        name_mic_site: _sample?.name_mic_site ?? "-------",
                        tests: formattedTests,
                        id_mic_sample: _sample.id_mic_sample,
                        id_mic_site: _sample.id_mic_site,
                        observations: _sample.observations ?? "------"



                    };
                })
                .filter(item =>
                    item !== null &&
                    item.tests.length > 0 &&
                    item.tests.some(test => test.test_name && test.price)
                );
        })
        .flat();

    const getFormattedPrice = (_find, valueTax) => {
        let priceStr;

        if (_find?.config_iva) {
            if (_find?.id_agreement === null || _find?.id_agreement === 0) {
                priceStr = number_format(_find?.price, 2);
            } else {
                priceStr = number_format((_find?.price_Agremment).toFixed(2));
            }
        } else {
            if (_find?.id_agreement === null || _find?.id_agreement === 0) {
                priceStr = number_format((_find?.price * (valueTax === 16 ? 1.16 : 1.08)).toFixed(2));
            } else {
                priceStr = number_format((_find?.price_Agremment * (valueTax === 16 ? 1.16 : 1.08)).toFixed(2));
            }
        }
        return parseFloat(priceStr.replace(/[^0-9.]/g, ""));
    };
    const truncateWords = (text, maxWords = 12) => {
        if (!text || text.trim() === "") return "";

        return text.length > maxWords
            ? text.substring(0, maxWords) + "..."
            : text;
    };








    return (
        <>
            <div className="email-wrap bookmark-wrap">
                <Col sm="12" className='p-l-0 p-r-0' >
                    <Card style={{ textAlign: "left" }} className="height-equal pricingtable pt-0 pb-0 pr-0 pl-0">
                        <Row>
                            <Col xl="4" className="box-col-6 p-r-0" >
                                <div className="email-left-aside">
                                    <CardBody>
                                        <Col sm="12" md="12" lg="12" className='p-r-0 pb-5'>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h5 className="f-w-600 mt-1" style={{ color: "#1d5b83" }} >{checkTypeClient === 1 ? "Particular" : "Empresa"}</h5>
                                                <ButtonGroup size="sm">
                                                    <Button color="dark" type="button" outline onClick={() => history.goBack()}>
                                                        <i className="icofont icofont-arrow-left"></i>&nbsp; Regresar
                                                    </Button>
                                                    <Button color="danger" type="button" outline onClick={() => handleCancelWorkOrderUpdate()}>
                                                        <i className="fa fa-times"></i> &nbsp; Cancelar
                                                    </Button>
                                                </ButtonGroup>
                                            </div>
                                        </Col>
                                        <div className="media">

                                            <Col sm="12" className='p-l-0 p-r-0' >
                                                <div className="media-body">
                                                    <Row>
                                                        <Col sm="2">
                                                            <img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/laboratory-External/laboratorio.png")} style={{ width: "60px", height: "60px" }} />

                                                        </Col>
                                                        <Col sm="10" className='p-l-0 p-r-0' >
                                                            <h5 className="f-w-600" style={{ fontSize: "14px" }} >{"Tipo de Ingreso:"} </h5>
                                                            <label className='f-w-500' >{checkTypeClient === 1 ? "Particular" : "Empresa"} </label> <br />
                                                            <b>{checkTypeClient === 1 ? "" : ""} {checkTypeClient === 1 ? <label className='txt-info'>{informationPatient?.name + " " + informationPatient?.paternal_surname + " " + informationPatient?.maternal_surname} </label> : <label className='f-w-600' > {(id_company?.label !== undefined ? <label className='txt-secondary' >{id_company?.label} </label> : "")} </label>} </b>  <br />
                                                            <label  ><strong>NIM:</strong>&nbsp;<label >{nim_Notification ?? "-----"}</label> </label>
                                                            {
                                                                informationSampling.length > 0 && informationSampling.map(_find => {
                                                                    return <Col sm="12" className='pt-0 '>
                                                                        <Row>
                                                                            <Col sm="12" className='p-l-0 p-r-0' >
                                                                                <label  ><strong>Cotización asociada</strong>&nbsp;<label className='txt-info f-w-600' >{_find?.name_quoter ?? "-----"}</label> </label>


                                                                            </Col>
                                                                            <Col sm="12" className=' p-l-0 p-r-0' >
                                                                                <label style={{ fontSize: "14px" }} className='f-w-600'>Descargar Cotización</label> <br />
                                                                                <Button size='sm' onClick={() => downloadQuoter(id_quoter, valueTax)} outline color='danger' ><i className='fa fa-file-pdf-o ' ></i></Button>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                })
                                                            }
                                                        </Col>

                                                    </Row>

                                                </div>

                                            </Col>

                                        </div>

                                    </CardBody>
                                </div>
                            </Col>
                            <Col xl="8" md="12" className="box-col-12">
                                <div className="email-right-aside bookmark-tabcontent contacts-tabs">
                                    <div className="email-body radius-left">
                                        <div className="pl-0">
                                            <TabContent activeTab={activeTab}>
                                                <TabPane tabId="2">
                                                    {isFirstLoad ? (
                                                        <>
                                                        </>

                                                    ) : (
                                                        <>
                                                            <Col sm="12" className=' pt-4' >
                                                                <Row>

                                                                    <Col sm="11"  >
                                                                        <h5 className='f-w-600' style={{ color: "#1d5b83" }} >Datos generales de la cotización</h5>

                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <CardBody className='pl-4 pr-4 pt-4 pb-5' >
                                                                <Row className="list-persons">
                                                                    <Col xl="4 xl-50" md="5" className='p-l-0' >
                                                                        <Nav className="flex-column nav-pills" id="v-pills-tab1" role="tablist" aria-orientation="vertical">
                                                                            {
                                                                                informationSampling.length > 0 && informationSampling.map(_find => {
                                                                                    return <Col sm="12" className='pt-0'  >
                                                                                        <Row>
                                                                                            <Col sm="6">
                                                                                                <label style={{ fontSize: "12px" }} ><i className="fa fa-circle text-primary"></i> Plan de muestreo</label> <br />
                                                                                                <label>{_find?.sampling_plan ?? "------"} </label>
                                                                                            </Col>
                                                                                            <Col sm="12" className='pt-5' >
                                                                                                <label style={{ fontSize: "12px" }}><i className="fa fa-circle text-primary"></i> Observaciones del muestreo:</label> <br />
                                                                                                <br />
                                                                                                <textarea
                                                                                                    className='form-control form-control-sm input-air-primary'
                                                                                                    rows="2"
                                                                                                    value={_find?.observation ?? "-----"}
                                                                                                    readOnly
                                                                                                ></textarea>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </Col>
                                                                                })
                                                                            }
                                                                        </Nav>
                                                                    </Col>
                                                                    <Col xl="8 xl-50" md="7">
                                                                        <TabContent activeTab={orgActiveTab}>
                                                                            <TabPane tabId="1">
                                                                                <Col sm="12" style={{ textAlign: "center" }} >
                                                                                    <label style={{ fontSize: "12px" }} ><i className="fa fa-circle text-primary"></i> Firmas de los que autorizaron el muestreo</label>
                                                                                    {
                                                                                        informationSampling.length > 0 && informationSampling.map(_find => {
                                                                                            return <Row className='pt-5' >
                                                                                                <Col sm="6">
                                                                                                    <label className='f-w-600' > Responsable del muestreo </label>
                                                                                                    <br />
                                                                                                    <img width={"100%"} alt="flask" src={ConfigServer.serverUrl + "/api/QuoterDeterminations/GetPictureFirm/" + _find?.firm_sampler} />
                                                                                                </Col>
                                                                                                <Col sm="6">
                                                                                                    <label className='f-w-600' >Firma del contacto/cliente </label>
                                                                                                    <img width={"100%"} alt="flask" src={ConfigServer.serverUrl + "/api/QuoterDeterminations/GetPictureFirm/" + _find?.firm_client} />

                                                                                                </Col>
                                                                                            </Row>
                                                                                        })
                                                                                    }
                                                                                </Col>
                                                                            </TabPane>
                                                                        </TabContent>
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                        </>
                                                    )}
                                                </TabPane>

                                            </TabContent>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Card>
                </Col>
                <Row>
                    <Col sm="12">
                        <Card>
                            <div className='pt-4 pb-4' >
                                <Col sm="12"  >
                                    <Row>
                                        <Col sm="5" className='pt-3' >
                                            <h5 className=' f-w-600' style={{ color: "#1d5b83" }} >Listado de Muestras</h5>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col sm="12" className='pt-3' >
                                    <Table className="b-r-5 table table-sm">
                                        <thead className="b-r-5" style={{ textAlign: "center", backgroundColor: "#1d5b83" }}>
                                            <tr >
                                                <th style={{ color: "#fff" }} ><b>Folio</b> </th>
                                                <th className={validPorcentejeSpecial === cedimi ? "d-none" : ""} style={{ color: "#fff", textAlign: "center" }}>
                                                    <i className="fa fa-trash-o" style={{ color: "#fff", fontSize: "14px" }}></i>
                                                </th>
                                                <th style={{ color: "#fff" }}> <b>Tipo de Muestra</b> </th>
                                                <th style={{ color: "#fff" }}> <b>Descripción de la muestra</b> </th>
                                                <th style={{ color: "#fff" }}> <b>Determinaciones</b> </th>
                                                <th style={{ color: "#fff" }}> <b>Lugar de toma</b> </th>
                                                <th style={{ color: "#fff" }}><b>Observaciones</b></th>
                                                <th style={{ color: "#fff" }}> <b>Precio</b> </th>
                                                <th style={{ color: "#fff" }} className={checkTypeClient === 1 ? "d-none" : ""} ><b>Convenio</b> </th>
                                                <th className={validPorcentejeSpecial === cedimi ? "d-none" : ""} style={{ color: "#fff", textAlign: "center" }}>
                                                    <i className="fa fa-trash-o" style={{ color: "#fff", fontSize: "14px" }}></i>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {groupedData.map((item, index) => {
                                                const pricesFormatted = item.tests.map((_find) => {
                                                    let priceStr;

                                                    if (_find?.config_iva) {
                                                        if (_find?.id_agreement === null || _find?.id_agreement === 0) {
                                                            priceStr = number_format(_find?.price, 2);
                                                        } else {
                                                            priceStr = number_format((_find?.price_Agremment).toFixed(2));
                                                        }
                                                    } else {
                                                        if (_find?.id_agreement === null || _find?.id_agreement === 0) {
                                                            priceStr = number_format((_find?.price * (valueTax === 16 ? 1.16 : 1.08)).toFixed(2));
                                                        } else {
                                                            priceStr = number_format((_find?.price_Agremment * (valueTax === 16 ? 1.16 : 1.08)).toFixed(2));
                                                        }
                                                    }
                                                    return parseFloat(priceStr.replace(/[^0-9.]/g, ""));
                                                });

                                                const idWo = item.tests.flatMap(_find => {
                                                    const ids = [];
                                                    if (_find.id_work_order_exam) ids.push(_find.id_work_order_exam);
                                                    if (_find.id_work_order_profile) ids.push(_find.id_work_order_profile);
                                                    return ids;
                                                });

                                                return (
                                                    <tr key={index} style={{ textAlign: "center", border: "1px solid #ddd" }}>
                                                        <td className="txt-secondary f-w-600" style={{ border: "1px solid #ddd", padding: "8px" }}>
                                                            {item.folio}
                                                        </td>
                                                        <td
                                                            className={validPorcentejeSpecial === cedimi ? "d-none" : ""}
                                                            style={{
                                                                border: "1px solid #ddd",
                                                                padding: "8px",
                                                                width: "50px",
                                                                maxWidth: "30px",
                                                                textAlign: "-webkit-center",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                            }}
                                                        >
                                                            <Button
                                                                size="sm"
                                                                color="danger"
                                                                onClick={(e) =>
                                                                    handleDeleteSample(
                                                                        true,
                                                                        item?.id_mic_detail_sample,
                                                                        item.name_mic_sample,
                                                                        pricesFormatted,
                                                                        idWo,
                                                                        item.folio,
                                                                        groupedData.length === 1 ? true : false
                                                                    )
                                                                }
                                                                style={{
                                                                    width: "30px",
                                                                    height: "30px",
                                                                    backgroundColor: "#e74c3c",
                                                                    borderColor: "#e74c3c",
                                                                    borderRadius: "50%",
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    padding: "0",
                                                                    boxShadow: "none",
                                                                    transition: "all 0.3s ease",
                                                                }}
                                                                onMouseEnter={(e) => (e.target.style.backgroundColor = "#c0392b")}
                                                                onMouseLeave={(e) => (e.target.style.backgroundColor = "#e74c3c")}
                                                                title={`Eliminar muestra de: ${item?.name_mic_sample}`}
                                                            >
                                                                <i className="fa fa-trash-o" style={{ color: "#fff", fontSize: "16px" }}></i>
                                                            </Button>
                                                        </td>
                                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>{item.name_mic_sample}</td>
                                                        <td className={_authorized_sanitary === "True" ? 'pointer' : ''}
                                                            onClick={(e) => {
                                                                if (_authorized_sanitary === "True") {
                                                                    setSelectedQuotation(item);
                                                                    op.current.toggle(e);
                                                                }
                                                            }}
                                                            style={{ border: "1px solid #ddd", padding: "8px" }}>{item.name_mic_sampling}
                                                            <OverlayPanel ref={op} showCloseIcon >
                                                                <Col sm="12" className='p-l-0 p-r-0' style={{ textAlign: "center" }} >
                                                                    <label style={{ fontSize: "10px" }} className=" f-w-700">
                                                                        {selectedQuotation?.name_mic_sampling}
                                                                    </label>
                                                                </Col>
                                                                <Col sm="12" >
                                                                    <Row>
                                                                        <Col sm="6">
                                                                            <Tag onClick={() => handleEdit(selectedQuotation.id_mic_detail_sample, selectedQuotation.id_mic_sample, selectedQuotation.name_mic_sampling, selectedQuotation.name_mic_sample, selectedQuotation.id_mic_site, false)} className="mr-2 pointer" icon="fa fa-edit" severity="success" value="Editar"
                                                                                style={{
                                                                                    fontSize: "10px",
                                                                                    padding: "2px 6px"
                                                                                }}
                                                                            ></Tag>
                                                                        </Col>
                                                                        <Col sm="6">
                                                                            <Tag onClick={() => handleEdit(selectedQuotation.id_mic_detail_sample, selectedQuotation.id_mic_sample, selectedQuotation.name_mic_sampling, selectedQuotation.name_mic_sample, selectedQuotation.id_mic_site, true)} className="mr-2 pointer" icon="fa fa-exchange" severity="warning" value="Cambiar" style={{
                                                                                fontSize: "10px",
                                                                                padding: "2px 6px"
                                                                            }}  ></Tag>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </OverlayPanel>
                                                        </td>
                                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                                            {item.tests.map((_find, i) => (
                                                                <div key={i} style={{ padding: "4px 0" }}>
                                                                    {_find?.test_name}
                                                                    {i !== item.tests.length - 1 && (
                                                                        <hr style={{ margin: "4px 0", borderColor: "#ddd" }} />
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </td>
                                                        <td
                                                            className={item._authorized_sanitary === "True" ? 'pointer' : ''}
                                                            onClick={(e) => {
                                                                if (_authorized_sanitary === "True") {
                                                                    setSelectedSiteQuotation(item);
                                                                    ops.current.toggle(e);
                                                                }
                                                            }}
                                                            style={{ border: "1px solid #ddd", padding: "8px" }}>{item.name_mic_site}
                                                            <OverlayPanel ref={ops} showCloseIcon >
                                                                <Col sm="12" className='p-l-0 p-r-0' style={{ textAlign: "center" }} >
                                                                    <label style={{ fontSize: "10px" }} className=" f-w-700">
                                                                        {selectedSiteQuotation?.name_mic_site}
                                                                    </label>
                                                                </Col>
                                                                <Col sm="12" >
                                                                    <Row>
                                                                        <Col sm="6">
                                                                            <Tag onClick={() => handleEditSite(selectedSiteQuotation.id_mic_detail_sample, selectedSiteQuotation.id_mic_sample, selectedSiteQuotation.name_mic_site, selectedSiteQuotation.name_mic_sample, selectedSiteQuotation.id_mic_site, false)} className="mr-2 pointer" icon="fa fa-edit" severity="success" value="Editar"
                                                                                style={{
                                                                                    fontSize: "10px",
                                                                                    padding: "2px 6px"
                                                                                }}
                                                                            ></Tag>
                                                                        </Col>
                                                                        <Col sm="6">
                                                                            <Tag onClick={() => handleEditSite(selectedSiteQuotation.id_mic_detail_sample, selectedSiteQuotation.id_mic_sample, selectedSiteQuotation.name_mic_site, selectedSiteQuotation.name_mic_sample, selectedSiteQuotation.id_mic_site, true)} className="mr-2 pointer" icon="fa fa-exchange" severity="warning" value="Cambiar" style={{
                                                                                fontSize: "10px",
                                                                                padding: "2px 6px"
                                                                            }}  ></Tag>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </OverlayPanel>
                                                        </td>
                                                        <td
                                                            className={item._authorized_sanitary === "True" ? 'pointer' : 'pointer'}
                                                            onClick={(e) => {
                                                                if (_authorized_sanitary === "True") {
                                                                    setSelectedObservation(item);
                                                                    opss.current.toggle(e);
                                                                }
                                                            }}
                                                        >
                                                            <OverlayPanel ref={opss} showCloseIcon >
                                                                <Col sm="12" className='p-l-0 p-r-0' style={{ textAlign: "center" }} >
                                                                    <label style={{ fontSize: "10px" }} className=" f-w-700">
                                                                        {selectedObservationQuotation?.observations}
                                                                    </label>
                                                                </Col>
                                                                <Col sm="12" >
                                                                    <Row>
                                                                        <Col sm="6">
                                                                            <Tag onClick={() => editObservation(selectedObservationQuotation.id_mic_detail_sample, selectedObservationQuotation.id_mic_sample, selectedObservationQuotation.name_mic_site, selectedObservationQuotation.name_mic_sample, selectedObservationQuotation.id_mic_site, false, selectedObservationQuotation.observations)} className="mr-2 pointer" icon="fa fa-edit" severity="success" value="Editar"
                                                                                style={{
                                                                                    fontSize: "10px",
                                                                                    padding: "2px 6px"
                                                                                }}
                                                                            ></Tag>
                                                                        </Col>

                                                                    </Row>
                                                                </Col>
                                                            </OverlayPanel>
                                                            <span title={item.observations}>
                                                                {truncateWords(item.observations, 12)}
                                                            </span>
                                                        </td>
                                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                                            {item.tests.map((_find, i) => {
                                                                return (<div key={i} style={{ padding: "4px 0" }}>
                                                                    {_find?.config_iva
                                                                        ? _find?.id_agreement === null || _find?.id_agreement === 0
                                                                            ? `$ ${number_format(_find?.price, 2)}`
                                                                            : `$ ${number_format((_find?.price_Agremment).toFixed(2))}`
                                                                        : _find?.id_agreement === null || _find?.id_agreement === 0
                                                                            ? `$ ${number_format((_find?.price * (valueTax === 16 ? 1.16 : 1.08)).toFixed(2))}`
                                                                            : `$ ${number_format((_find?.price_Agremment * (valueTax === 16 ? 1.16 : 1.08)).toFixed(2))}`}
                                                                    {i !== item.tests.length - 1 && (<hr style={{ margin: "4px 0", borderColor: "#ddd" }} />)}
                                                                </div>);
                                                            })}
                                                        </td>
                                                        <td
                                                            className={checkTypeClient === 1 ? "d-none" : ""}
                                                            style={{ border: "1px solid #ddd", padding: "8px" }}
                                                        >
                                                            {item.tests.map((_find, i) => (
                                                                <div key={i} style={{ padding: "4px 0" }}>
                                                                    {_find?.contract_number}
                                                                    {i !== item.tests.length - 1 && (
                                                                        <hr style={{ margin: "4px 0", borderColor: "#ddd" }} />
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </td>
                                                        <td className={validPorcentejeSpecial === cedimi ? "d-none" : ""}>
                                                            {item.tests.map((_find, i) => {

                                                                const priceFormatted = getFormattedPrice(_find, valueTax);

                                                                return (
                                                                    <Button
                                                                        key={i}
                                                                        size="sm"
                                                                        color="danger"
                                                                        onClick={(e) =>
                                                                            handleDeleteSample(
                                                                                false,
                                                                                item?.id_mic_detail_sample,
                                                                                _find?.test_name,
                                                                                priceFormatted,
                                                                                _find?.id_work_order_exam,
                                                                                item.folio,
                                                                                false,
                                                                                _find?.id_work_order_profile,
                                                                                groupedData
                                                                            )
                                                                        }
                                                                        style={{
                                                                            width: "30px",
                                                                            height: "30px",
                                                                            backgroundColor: "#e74c3c",
                                                                            borderColor: "#e74c3c",
                                                                            borderRadius: "50%",
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            alignItems: "center",
                                                                            padding: "0",
                                                                            boxShadow: "none",
                                                                            transition: "all 0.3s ease",
                                                                            marginBottom: "6px",
                                                                        }}
                                                                        onMouseEnter={(e) => (e.target.style.backgroundColor = "#c0392b")}
                                                                        onMouseLeave={(e) => (e.target.style.backgroundColor = "#e74c3c")}
                                                                        title={`Eliminar determinación de: ${_find?.test_name}`}
                                                                    >
                                                                        <i className="fa fa-trash-o" style={{ color: "#fff", fontSize: "16px" }}></i>
                                                                    </Button>
                                                                );
                                                            })}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </Col>
                            </div>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Row>
                                <Col sm="4" className='pr-0' >
                                    <Col sm="12" className='pt-5 pb-3 pr-4 pl-4' >
                                        <h5 className='f-w-600' style={{ color: "#1d5b83" }} >Datos de cobranza</h5>
                                        <Row className='pt-3' >
                                            <div className='deni-react-treeview-container-micro ' >
                                                <Col sm="12" className='pt-4' >
                                                    <Row>
                                                        <Col sm="6">
                                                            <label style={{ fontSize: "12px" }} className='f-w-600 '><i className="fa fa-circle text-primary"></i>&nbsp;Generar pago a</label> <br />
                                                            <label className='f-w-300' >{isPayForCompany ? "Empresa" : "Paciente"} </label> <br />
                                                        </Col>
                                                        <Col sm="6">
                                                            <label style={{ fontSize: "12px" }} className='f-w-600 '><i className="fa fa-circle text-primary"></i>&nbsp; Generar factura a</label> <br />
                                                            <label className='f-w-300'>Empresa</label> <br />
                                                        </Col>
                                                        <Col sm="6" className='pt-3' >
                                                            <label style={{ fontSize: "12px" }} className='f-w-600  '><i className="fa fa-circle text-primary"></i>&nbsp; Requiere factura:  </label> <br /> <label className='f-w-500  txt-danger' >{checkInvoice ? "Si" : "No"}</label>
                                                        </Col>
                                                        <Col sm="6">
                                                            {
                                                                informationSampling.length > 0 && informationSampling.map(_find => {
                                                                    return <Col sm="12" className='pt-0 p-l-0 p-r-0 '  >
                                                                        <label className='f-w-600' style={{ fontSize: "12px" }} ><i className="fa fa-circle text-primary"></i>&nbsp; Configuración del Iva</label> <br />
                                                                        <label className={_find?.tax_border ? "txt-secondary f-w-600 f-14" : " f-14 txt-info f-w-600"} >{!_find?.tax_border ? "Iva al 16%" : "Iva al 8%"} </label>
                                                                    </Col>
                                                                })
                                                            }
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </div>
                                        </Row>
                                    </Col>
                                </Col>
                                <Col sm="8" className='pl-0' >
                                    <Col sm="12" className='pt-5 pb-3 pr-4 pl-4' >
                                        <h5 className='f-w-600' style={{ color: "#1d5b83" }} >Detalles del pago
                                        </h5>
                                        <Row className='m-t-5 p-1'>
                                            <Col sm="12" md="6" lg="6" xl="6" className=' mt-2 pl-4'>
                                                <Row className='m-t-15'>
                                                    <Table style={{ fontSize: "11px" }}>
                                                        <thead>
                                                            <tr style={{ backgroundColor: "#1d5b83" }}>
                                                                <td colSpan={3} style={{ color: "#fff", textAlign: "center", padding: "5px" }}>
                                                                    Detalle de Pagos
                                                                </td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ padding: "5px", textAlign: "center" }}>
                                                                    <label className=''>Método de pago</label>
                                                                </td>
                                                                <td className="text-center" style={{ padding: "5px" }}>
                                                                    <label>Monto</label>
                                                                </td>
                                                                <td style={{ padding: "5px" }}>
                                                                    <label className=''>Acciones</label>
                                                                </td>
                                                            </tr>
                                                            {
                                                                listPayMethods.map((_paymethod, keyPayment) => {
                                                                    return (
                                                                        <tr key={`method-${keyPayment}`} className={_paymethod.deleted ? 'd-none' : ''}>
                                                                            <td>
                                                                                <Input type="select" required={true} className='form-control form-control-sm input-air-primary p-1' value={_paymethod.id_pay_method} data-id={keyPayment}
                                                                                    onChange={(e) => handleDinamicInputWorkOrder(e, "id_pay_method", "listPayMethods")} disabled={validTotalCredit ? true : (_paymethod.id_work_order_pay !== undefined && _paymethod.id_work_order_pay !== null) ? true : (totalW >= 0 ? false : true)}>
                                                                                    <option value={0}>Selecciona una opción</option>
                                                                                    {
                                                                                        listPayMethod.map(_pMethod => {
                                                                                            if (checkTypeClient === 3 && isPayForCompany) {

                                                                                                if (_pMethod.name === AvailablePayMethodByCompany) {
                                                                                                    return (
                                                                                                        <option value={_pMethod.id_pay_method} key={`method-${_pMethod.id_pay_method}`}>{`${_pMethod.abbreviation} - ${_pMethod.name}`}</option>
                                                                                                    )
                                                                                                }
                                                                                            }
                                                                                            else if (_pMethod.abbreviation !== "CONV") {

                                                                                                if (_adminFinance === "True") {
                                                                                                    return (
                                                                                                        <option value={_pMethod.id_pay_method} key={`method-${_pMethod.id_pay_method}`}>{`${_pMethod.abbreviation} - ${_pMethod.name}`}</option>
                                                                                                    )
                                                                                                }
                                                                                                else {
                                                                                                    if (_pMethod.visibility_particular === true) {
                                                                                                        return (
                                                                                                            <option value={_pMethod.id_pay_method} key={`method-${_pMethod.id_pay_method}`}>{`${_pMethod.abbreviation} - ${_pMethod.name}`}</option>
                                                                                                        )
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        })
                                                                                    }
                                                                                </Input>
                                                                            </td>
                                                                            <td>
                                                                                <Input type='number' name="amount" data-id={keyPayment} value={_paymethod.amount} placeholder='$ 0.0' step="any"
                                                                                    className='form-control input-air-primary form-control-sm' onChange={(e) => handleGiveChange(e, "amount", "listPayMethods")}
                                                                                    disabled={validTotalCredit ? true : (_paymethod.id_work_order_pay !== undefined && _paymethod.id_work_order_pay !== null) ? true : (totalW >= 0 ? false : true)}
                                                                                />
                                                                            </td>
                                                                            <td className={validTotalCredit ? "d-none" : 'p-1 text-center'} style={{ verticalAlign: "middle" }} colSpan={3}  >
                                                                                {

                                                                                    (_paymethod.fully_paid !== undefined && !_paymethod.fully_paid) ?
                                                                                        <Button type='button' className='btn-air-success' outline color='success' size='xs' onClick={() => handlePayBill(_paymethod.id_work_order_pay, _paymethod.amount)}>
                                                                                            <i className="fa fa-money"></i>
                                                                                        </Button>
                                                                                        :
                                                                                        <Button type='button' className='btn-air-danger' outline color='danger' size='xs' onClick={() => handleDeletePayMethod(keyPayment)}
                                                                                            disabled={(_paymethod.id_work_order_pay !== undefined && _paymethod.id_work_order_pay !== null) ? true : (totalW > 0 ? false : true)}
                                                                                        >
                                                                                            <i className='icofont icofont-ui-delete'></i>
                                                                                        </Button>
                                                                                }

                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            }


                                                        </tbody>
                                                        {
                                                            !validTotalCredit &&
                                                            <tfoot>
                                                                <tr>
                                                                    <td colSpan={3} className="text-xs-center">
                                                                        <FormText color='danger' hidden={!listPayMethods_valid}>Selecciona un metodo de pago o ingresa la cantidad correcta</FormText>
                                                                    </td>
                                                                </tr>
                                                            </tfoot>
                                                        }
                                                    </Table>
                                                </Row>
                                            </Col>
                                            <Col sm="1">
                                            </Col>
                                            <Col sm="12" md="5" lg="5" xl="5" className=' p-l-0 mt-2'>
                                                <Row className='m-t-15' style={{ textAlignLast: 'center' }}>
                                                    <Col sm="12">
                                                        <Table style={{ fontSize: "11px" }}>
                                                            <thead>
                                                                <tr style={{ backgroundColor: "#1d5b83" }}>
                                                                    <td colSpan={2} style={{ color: "#fff", textAlign: "center", padding: "5px" }}>
                                                                        Detalle de movimientos
                                                                    </td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ padding: "5px" }}>
                                                                        <label className='f-12'>Subtotal</label>
                                                                    </td>
                                                                    <td className="text-center" style={{ padding: "5px" }}>
                                                                        <label>$ {number_format(subTotalW, 2)}</label>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ padding: "5px" }}>
                                                                        <label style={{ fontSize: "13px" }} className={valueTax === 16 ? 'f-w-600 txt-primary' : 'f-w-600 txt-secondary'}  >I.V.A({valueTax}%)</label>

                                                                    </td>
                                                                    <td className="text-center" style={{ padding: "5px" }}>
                                                                        <label>$ {number_format(totalTaxesW, 2)}</label>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ padding: "5px" }}>
                                                                        <label style={{ fontSize: "13px" }} className='f-w-600'>Total</label>
                                                                    </td>
                                                                    <td className="text-center f-w-600 bg-dark" style={{ padding: "5px" }}>
                                                                        <label style={{ fontSize: "13px" }} className='f-w-600'>$ {number_format(totalW, 2)}</label>
                                                                    </td>
                                                                </tr>

                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>

                                            </Col>
                                        </Row>

                                    </Col>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <br />
                <br />
            </div>
            <Dialog
                header={dataInfo.title}
                visible={modalSample}
                onHide={toggleModalSample}
                headerStyle={{
                    backgroundColor: '#cb0b1d',
                    color: 'white',
                    fontWeight: 'bold',
                }}
                pt={{
                    header: { style: { backgroundColor: '#cb0b1d', color: 'white' } },
                    headerIcon: { style: { color: 'white' } },
                }}
                className="pt-0 custom-dialog-img-sample"
                footer={
                    <div>
                        <Button disabled={loadingIsDevolution ? true : false} onClick={() => dataInfo.isSample ? deleteSamplingOrder() : deleteSamplingOrder()} color='secondary' type="button"> <i className={loadingIsDevolution ? "pi pi-spin pi-spinner" : null} style={{ fontSize: "0.8rem" }} /> {loadingIsDevolution ? "Guardando" : "Guardar"}</Button>
                    </div>
                }
            >
                <Col sm="12" className='pt-2 p-l-0 p-r-0' >
                    <label style={{ color: "#565a5efc", fontWeight: "bold", fontSize: "15px" }}  >{dataInfo.message}</label> <br />
                    <label>{dataInfo.message_bold}</label   >
                    <br /> <br />
                    <Col className='shadow-sm' sm="12"
                        style={{
                            backgroundColor: 'white',
                            border: '1px solid #e0e0e0',
                            borderRadius: '10px',
                            padding: '12px',
                            fontSize: '12px'
                        }}>
                        <label className='txt-danger f-w-700'>Selecciona un motivo por el que se cancelara</label>
                        <Select
                            classNamePrefix="select"
                            name="id_mic_return_reason"
                            value={dataInfo?.id_mic_return_reason}
                            placeholder="Selecciona un motivo"
                            options={listReturnReason}
                            onChange={(e) => handleChangeReturnReason(e,)}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 })
                            }}
                        />
                        <br /><br /><br />
                    </Col>
                </Col>
            </Dialog>
            {
                // ? UPDATE SAMPLE
            }
            <Dialog
                header={formMic.name_mic_sample}
                visible={modalUpdateSample}
                onHide={toggleModalUpdateSample}
                headerStyle={{
                    backgroundColor: '#0d3b59',
                    color: 'white',
                    fontWeight: 'bold',
                }}
                pt={{
                    header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                    headerIcon: { style: { color: 'white' } },
                }}
                className="pt-0 custom-dialog-img-sample"
                footer={
                    <div>
                        {
                            formMic.is_change ?
                                <Button disabled={loadingUpdate ? true : false} onClick={() => saveUpdateChangeSampling()} color='secondary' type="button"> Guardar </Button>

                                :
                                <Button disabled={loadingUpdate ? true : false} onClick={() => saveUpdateSampling()} color='secondary' type="button"> Guardar </Button>

                        }
                    </div>
                }
            >
                <Col sm="12" className={formMic.is_change ? "d-none" : 'pt-2 p-l-0 p-r-0'}  >
                    <label style={{ fontSize: "14px" }} >Se modificara el tipo de muestra:&nbsp; <b>{formMic.name_mic_sampling} </b> </label>
                    <Col sm="12" className='p-l-0 p-r-0 pt-3 pb-3' >
                        <input
                            value={formMic.name_newSampling}
                            name="name_newSampling"
                            onChange={handleChangeSample}
                            className="mr-2 input-line2"
                            style={{ fontSize: "14px" }}
                        />
                    </Col>
                    <div
                        style={{
                            color: "#856404",
                            fontSize: "10px",
                            marginTop: "6px",
                            fontWeight: "500",
                            backgroundColor: "#fff3cd",
                            padding: "4px 10px",
                            borderRadius: "6px",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            border: "1px solid #ffeeba",
                        }}
                    >
                        <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
                        {"Se modificara desde el catalógo de tipo de muestras." ?? "---"}
                    </div>

                </Col>
                <Col wsm="12" className={!formMic.is_change ? "d-none" : 'pt-2 p-l-0 p-r-0'} >
                    <label style={{ fontSize: "14px" }} >Se cambiara la descripción de muestra:&nbsp; <b>{formMic.name_mic_sampling} </b> </label>
                    <Col sm="12" className='p-l-0 p-r-0 pt-3 pb-3'  >
                        <Select
                            classNamePrefix="select"
                            name="id_mic_sample_change"
                            value={formMic?.id_mic_sample_change}
                            placeholder="Selecciona un sitio"
                            options={listSample}
                            onChange={(e) => handleSample(e)}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 })
                            }}
                        />
                    </Col>
                    <div
                        className={formMic.id_mic_sample_change === null ? "d-none" : ""}
                        style={{
                            color: "#856404",
                            fontSize: "10px",
                            marginTop: "6px",
                            fontWeight: "500",
                            backgroundColor: "#fff3cd",
                            padding: "4px 10px",
                            borderRadius: "6px",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            border: "1px solid #ffeeba",
                        }}
                    >
                        <i
                            className="fa fa-exclamation-triangle"
                            style={{ color: "#d39e00" }}
                        ></i>

                        <p style={{ fontSize: "10px", margin: 0 }}>
                            Se cambiará la descripción{" "}
                            <strong>{formMic.name_mic_sampling || "---"}</strong>
                            {" por "}
                            <strong>{formMic.id_mic_sample_change?.label || ""}</strong>.
                        </p>
                    </div>

                </Col>
            </Dialog >
            {
                // ? UPDATE SITE

            }
            <Dialog
                header={formMic.name_mic_sample}
                visible={modalUpdateSite}
                onHide={toggleModalUpdateSite}
                headerStyle={{
                    backgroundColor: '#0d3b59',
                    color: 'white',
                    fontWeight: 'bold',
                }}
                pt={{
                    header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                    headerIcon: { style: { color: 'white' } },
                }}
                className="pt-0 custom-dialog-img-sample"
                footer={
                    <div>
                        {
                            formMic.is_change ?
                                <Button disabled={loadingUpdate ? true : false} onClick={() => saveUpdateChangeSite()} color='secondary' type="button"> Guardar </Button>

                                :
                                <Button disabled={loadingUpdate ? true : false} onClick={() => saveUpdateSite()} color='secondary' type="button"> Guardar </Button>

                        }
                    </div>
                }
            >
                <Col sm="12" className={formMic.is_change ? "d-none" : 'pt-2 p-l-0 p-r-0'}  >
                    <label style={{ fontSize: "14px" }} >Se modificara el lugar de la toma:&nbsp; <b>{formMic.name_mic_site} </b> </label>
                    <Col sm="12" className='p-l-0 p-r-0 pt-3 pb-3' >
                        <input
                            value={formMic.name_newSite}
                            name="name_newSite"
                            onChange={handleChangeSite}
                            className="mr-2 input-line2"
                            style={{ fontSize: "14px" }}
                        />
                    </Col>
                    <div
                        style={{
                            color: "#856404",
                            fontSize: "10px",
                            marginTop: "6px",
                            fontWeight: "500",
                            backgroundColor: "#fff3cd",
                            padding: "4px 10px",
                            borderRadius: "6px",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            border: "1px solid #ffeeba",
                        }}
                    >
                        <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
                        {"Se modificara desde el catalógo de sitios." ?? "---"}
                    </div>

                </Col>
                <Col wsm="12" className={!formMic.is_change ? "d-none" : 'pt-2 p-l-0 p-r-0'} >
                    <label style={{ fontSize: "14px" }} >Se cambiara el lugar de la muestra:&nbsp; <b>{formMic.name_mic_site} </b> </label>
                    <Col sm="12" className='p-l-0 p-r-0 pt-3 pb-3'  >
                        <Select
                            classNamePrefix="select"
                            name="id_mic_site_change"
                            value={formMic?.id_mic_site_change}
                            placeholder="Selecciona un sitio"
                            options={listSite}
                            onChange={(e) => handleSite(e)}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 })
                            }}
                        />
                    </Col>
                    <div
                        className={formMic.id_mic_site_change === null ? "d-none" : ""}
                        style={{
                            color: "#856404",
                            fontSize: "10px",
                            marginTop: "6px",
                            fontWeight: "500",
                            backgroundColor: "#fff3cd",
                            padding: "4px 10px",
                            borderRadius: "6px",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            border: "1px solid #ffeeba",
                        }}
                    >
                        <i
                            className="fa fa-exclamation-triangle"
                            style={{ color: "#d39e00" }}
                        ></i>

                        <p style={{ fontSize: "10px", margin: 0 }}>
                            Se cambiará el lugar{" "}
                            <strong>{formMic.name_mic_site || "---"}</strong>
                            {" por "}
                            <strong>{formMic.id_mic_site_change?.label || ""}</strong>.
                        </p>
                    </div>

                </Col>
            </Dialog >

            {
                // ? UPDATE OBSERVATION
            }

            <Dialog
                header="Observaciones"
                visible={modalUpdateObservation}
                onHide={toggleModalUpdateObservation}
                headerStyle={{
                    backgroundColor: '#0d3b59',
                    color: 'white',
                    fontWeight: 'bold',
                }}
                pt={{
                    header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                    headerIcon: { style: { color: 'white' } },
                }}
                className="pt-0 custom-dialog-img-sample"
                footer={
                    <div>
                        <Button disabled={loadingUpdate ? true : false} onClick={() => saveUpdateObservation()} color='secondary' type="button"> Guardar </Button>
                        <Button disabled={loadingUpdate ? true : false} onClick={toggleModalUpdateObservation} color='danger' type="button"> Cancelar </Button>
                    </div>
                }
            >
                <Col sm="12" className={formMic.is_change ? "d-none" : 'pt-2 p-l-0 p-r-0'}  >
                    <label style={{ fontSize: "14px" }} >Se modificara la observacion:&nbsp; <b>{formMic.observationsM} </b> </label>
                    <Col sm="12" className='p-l-0 p-r-0 pt-3 pb-3' >
                        <input
                            value={formMic.observationsN}
                            name="observationsN"
                            onChange={handleChangeObservation}
                            className="mr-2 input-line2"
                            style={{ fontSize: "14px" }}
                        />
                    </Col>
                    <div
                        className={formMic.observationsN === null ? "d-none" : ""}
                        style={{
                            color: "#856404",
                            fontSize: "12px",
                            marginTop: "6px",
                            fontWeight: "500",
                            backgroundColor: "#fff3cd",
                            padding: "4px 10px",
                            borderRadius: "6px",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            border: "1px solid #ffeeba",
                        }}
                    >
                        <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
                        {`Este sera la nueva observación:  ${formMic.observationsN}`}
                    </div>
                </Col>
            </Dialog >
        </>
    );
};